const userTypeIdSet = {
  // need to make these objects env specific.
  retailUserType: 1,
  rmUserType: 2,
  headUserType: 3,
  managerUserType: 4,
  executiveUserType: 5,
  businessAdminUserType: 14,
  corporateUserType: 15,
  apiClientUserType: 16,
  viewOnlyExecutiveUserType: 19,
};

export const OTHER_DOCUMENT_TYPE = "OTHER_SUPPORTING_DOCUMENTS";
export const ORDER_DOCUMENT_USER_TYPE = "EXTERNAL";
export const ORDER_DOCUMENTS_EXCLUDED_COUNTRY_IDS = [97, 44];
export const MAX_FILE_SIZE_BYTES = 5 * 1024 * 1024;
export const ALLOWED_MIME_TYPES = [
  "application/pdf",
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/vnd.ms-excel",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "image/jpeg",
  "image/jpg",
  "image/png",
  "image/gif",
];

// value = API documentType code; label = UI display text
export const ORDER_DOCUMENT_TYPES = [
  {
    value: "ANNUAL_RETURN",
    label: "Annual reports or Financials",
  },
  {
    value: "CONSTITUTIONAL_INCORPORATION",
    label: "Constitutional and incorporation documents",
  },
  {
    value: "CERTIFICATE_OF_INCUMBENCY",
    label: "Certificates of Incumbency",
  },
  {
    value: "REGISTRY_EXTRACTS",
    label: "Registry extracts",
  },
  {
    value: "OTHER_SUPPORTING_DOCUMENTS",
    label: "Other supporting documents",
  },
];

export function getOrderDocumentTypeLabel(documentType) {
  const match = ORDER_DOCUMENT_TYPES.find(
    (type) => type.value === documentType || type.label === documentType
  );
  return match?.label || documentType || "-";
}

export const companiesToShowExtraDeliveryTime = [
  "China",
  "United Kingdom",
  "Germany",
  "France",
  "Italy",
  "Netherlands",
  "Austria",
  "Denmark",
  "Norway",
  "Belgium",
  "Sweden",
  "Luxembourg",
  "Ireland",
];

export default userTypeIdSet;
